<template>
  <TopHeader v-if="isMobile()"/>
  <RadioPlayer v-if="isMobile()"/>
  <router-view v-if="isMobile()"/>
  <BottomNavigation v-if="isMobile()"/>
  <InstallPopup v-if="isMobile()"/>
  <DesktopCatch v-else />
</template>

<script>
import TopHeader from "./components/TopHeader";
import BottomNavigation from "./components/BottomNavigation";
import RadioPlayer from "@/components/RadioPlayer";
import InstallPopup from "@/components/InstallPopup";
import DesktopCatch from "@/components/DesktopCatch";


export default {
  mounted() {
    if (navigator.userAgent.match(/samsung/i)) {
       alert("Je maakt gebruik van een browser (Samsung Internet) die " + 
             "wellicht niet juist is ingesteld om deze app goed te laten zien. " +
             "We raden je aan om deze browser niet te gebruiken. \n\n"+
             "Deze app is het beste te gebruiken op Google Chrome.");
    }
  },
  methods: {
    isMobile() {
      if(window.location.href.indexOf("admin") > -1) {
        return true
      } else {
        return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
      }
    }
    
  },
  components: {
    TopHeader,
    BottomNavigation,
    RadioPlayer,
    InstallPopup,
    DesktopCatch
  },
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}

html {
  padding-bottom: env(safe-area-inset-bottom, 50px);
}

body {
  overscroll-behavior-y: contain;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  justify-content: center;
}

/* Overall padding for the centre container */
#app .page {
    padding: 16px;
}

/* ------------------------------------------------------------------------------------------ */

/* Smooth scrolling for YoutubeAPI-component */
html {
  scroll-behavior: smooth;
}

/* ------------------------------------------------------------------------------------------ */

/* Extra padding for the BottomNavigation-component */
@media only screen and (min-device-width: 320px) and (max-device-width: 1199px) {
  #app {
    padding-bottom: 56px;
  }
}

@media only screen and (min-device-width: 1200px){
  #app {
    padding-top: 80px;
  }
}

/* ------------------------------------------------------------------------------------------ */

/* Extra padding for the TopHeader-component */
@media only screen and (min-device-width: 320px) and (max-device-width: 1199px) {
  #app {
    padding-top: 58px;
  }
}

/* ------------------------------------------------------------------------------------------ */

/* Extra padding for the RadioPlayer-component*/
#app .page {
  padding-bottom: 74px;
}

@media only screen and (min-device-width: 1200px)  {
  #app .page {
      padding-top: 90px
  }
}

/* ------------------------------------------------------------------------------------------ */

/* Remove bottom padding and margin when a keyboard is active*/
#app .keyboard-space {
  padding-bottom: 0px !important;
}

#app .keyboard-space #chatbox {
  margin-bottom: 20px !important;
}
</style>
